<template>
    <label class="label cursor-pointer justify-start gap-3 operation-toggle-field">
        <input :checked="value" type="checkbox" class="toggle toggle-primary" @change="$emit('input', $event.target.checked)" />
        <span class="operation-toggle-field__content">
            <span class="label-text">{{ label }}</span>
            <small v-if="description">{{ description }}</small>
        </span>
    </label>
</template>

<script>
export default {
    name: 'ToggleField',
    props: {
        value: { type: Boolean, default: false },
        label: { type: String, default: '' },
        description: { type: String, default: '' }
    }
}
</script>

<style scoped>
.operation-toggle-field {
    align-items: flex-start;
    padding: 9px 10px;
    border: 1px solid oklch(var(--bc) / .1);
    border-radius: 8px;
    background: oklch(var(--b2) / .28);
}

.operation-toggle-field:hover,
.operation-toggle-field:focus-within {
    border-color: oklch(var(--p) / .28);
    background: oklch(var(--p) / .045);
}

.operation-toggle-field__content {
    display: grid;
    min-width: 0;
    gap: 3px;
}

.operation-toggle-field__content small {
    color: oklch(var(--bc) / .62);
    font-size: 12px;
    line-height: 1.45;
}
</style>
